import { render, staticRenderFns } from "./StopListPanel.vue?vue&type=template&id=2eb36da4&scoped=true&"
import script from "./StopListPanel.vue?vue&type=script&lang=js&"
export * from "./StopListPanel.vue?vue&type=script&lang=js&"
import style0 from "./StopListPanel.vue?vue&type=style&index=0&id=2eb36da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb36da4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb36da4')) {
      api.createRecord('2eb36da4', component.options)
    } else {
      api.reload('2eb36da4', component.options)
    }
    module.hot.accept("./StopListPanel.vue?vue&type=template&id=2eb36da4&scoped=true&", function () {
      api.rerender('2eb36da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DispatchDashboard/components/StopListPanel.vue"
export default component.exports